"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _fieldHelp = _interopRequireDefault(require("./field-help.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const FieldHelp = ({
  children,
  labelInline,
  labelWidth,
  ...rest
}) => /*#__PURE__*/_react.default.createElement(_fieldHelp.default, _extends({
  "data-element": "help",
  labelInline: labelInline,
  labelWidth: labelWidth
}, rest), children);

FieldHelp.propTypes = {
  /** Child elements */
  children: _propTypes.default.node,

  /** When true, label is placed in line an input */
  labelInline: _propTypes.default.bool,

  /** Width of a label in percentage. Works only when labelInline is true */
  labelWidth: _propTypes.default.number
};
var _default = FieldHelp;
exports.default = _default;